export const hints = {
  teamLeadApprovedRejected: "Atsakingas asmuo patvirtino atmestą darbą",
};

export const labels = {
};

export const errors  = {
};